var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"inline-flex select-none items-center",class:{
    'cursor-not-allowed opacity-25': _vm.isDisabled,
    'cursor-pointer': !_vm.isDisabled,
  },attrs:{"data-component":"CsToggle"}},[_c('div',{staticClass:"relative"},[_c('input',{staticClass:"sr-only",attrs:{"type":"checkbox","disabled":_vm.isDisabled},domProps:{"value":_vm.value},on:{"change":_vm.handleCheckboxChange}}),_vm._v(" "),_c('div',{staticClass:"block h-[18px] w-[26px] rounded-full",class:{
        'bg-[#1F94FF]': _vm.value && !_vm.isDisabled,
        'bg-[#90879B]': !_vm.value || _vm.isDisabled,
      }}),_vm._v(" "),_c('div',{staticClass:"dot absolute left-1 top-1 h-2.5 w-2.5 rounded-full bg-white transition",class:{ 'translate-x-[8px] bg-white': _vm.value }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }